import { FC, JSX, useState } from 'react';
import { Property } from '@model';
import { QuickViewContext, QuickViewModel } from './QuickViewContext.ts';

export const QuickViewProvider: FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const [showModalProperty, setShowModalProperty] = useState(
    undefined as Property | undefined,
  );

  const model = {
    hideQuickViewModal: () => setShowModalProperty(undefined),
    showQuickViewModal: (property: Property) => setShowModalProperty(property),
    quickViewModalProperty: showModalProperty,
  } as QuickViewModel;

  return (
    <QuickViewContext.Provider value={model}>
      {children}
    </QuickViewContext.Provider>
  );
};
